<template>
  <div class="user-info-prompt-modal-section">
    <common-modal-section @close="handleClicked">
      <div slot="header" class="user-info-prompt-modal-section__header">
        <p class="user-info-prompt-modal-section__title">
          {{ $tc('HomePage.UserInfoPromptModal.title') }}
        </p>
      </div>

      <div class="user-info-prompt-modal-section__body">
        <p class="user-info-prompt-modal-section__message">
          {{ $tc('HomePage.UserInfoPromptModal.message') }}
        </p>
        <ul class="user-info-prompt-modal-section__note">
          <li
            v-for="(note, index) in $t('HomePage.UserInfoPromptModal.note')"
            :key="index"
            v-html="note"
          ></li>
        </ul>
        <p class="user-info-prompt-modal-section__mission">
          {{ $tc('HomePage.UserInfoPromptModal.mission') }}
        </p>
      </div>

      <div slot="buttons" class="user-info-prompt-modal-section__buttons">
        <ul class="user-info-prompt-modal-section__buttons__list">
          <li class="user-info-prompt-modal-section__buttons__item">
            <p @click="handleClicked('/mypage/user-edit')">
              <atom-router-button
                to=""
                :linkText="$tc('HomePage.UserInfoPromptModal.buttonLabel')"
                colorType="secondary"
              />
            </p>
          </li>
          <li class="user-info-prompt-modal-section__buttons__item">
            <p @click="handleClicked('/mission')">
              <atom-router-button
                to=""
                :linkText="$tc('HomePage.UserInfoPromptModal.missionButtonLabel')"
                colorType="tertiary"
              />
            </p>
          </li>
          <li class="user-info-prompt-modal-section__buttons__item">
            <atom-button
              :linkText="$tc('common.close')"
              colorType="tertiary"
              @onClick="handleClicked('')"
            />
          </li>
        </ul>
      </div>
    </common-modal-section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import CommonModalSection from '@/components/common/modal/CommonModalSection.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'
import AtomButton from '@/components/atoms/AtomButton.vue'

/**
 * 会員情報入力催促モーダル セクション
 */
export default defineComponent({
  name: 'UserInfoPromptModalSection',
  components: { AtomButton, AtomRouterButton, CommonModalSection },
  setup(_, { emit }) {
    /**
     * 会員情報入力催促モーダルにあるボタンが押下された時の処理
     */
    const handleClicked = (destination: string) => {
      emit('onClick', destination)
    }

    return {
      handleClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.user-info-prompt-modal-section {
  color: $gray75;

  &__header {
    padding: 36px 16px 0;
  }

  &__title {
    font-size: 17px;
    font-weight: 500;
  }

  &__body {
    margin-top: 16px;
  }

  &__message {
    font-size: 13px;
    font-weight: 500;
  }

  &__note {
    margin: 16px auto 0;
    text-align: left;
    font-size: 10px;
    font-weight: 500;
    width: 190px;
    list-style-type: disc;
    padding-left: 20px;
  }

  &__mission {
    margin-top: 16px;
    font-size: 13px;
    font-weight: 500;
  }

  &__buttons {
    width: 100%;
    margin-top: 16px;

    &__item {
      + .user-info-prompt-modal-section__buttons__item {
        margin-top: 8px;
      }
    }
  }
}
</style>
